   
  <p *ngIf="value && values[value]">{{values[value]?.translation_key|| values[value].label| translation|translationFromString | transformText :values?.[value]?.text_transform}}</p> 
